import {
  CLASS_DEMO_DASHBOARD_PATH,
  CLASS_DEMO_PATH,
} from "./demoClassExperience";

export const CLASS_DEMO_CHOOSER_CTA = "Try Class Demo →";

export const CLASS_DEMO_CHOOSER_MODAL = {
  title: "Choose your demo",
};

export const CLASS_DEMO_CHOOSER_OPTIONS = [
  {
    id: "student",
    label: "I'm a student",
    description: "RSVP to reserve — credit used at check-in · ~1 min",
    to: CLASS_DEMO_PATH,
    testId: "class-demo-chooser-student",
  },
  {
    id: "instructor",
    label: "I'm the instructor",
    description: "Roster, Mark Present, walk-ins — ~4 min",
    to: CLASS_DEMO_DASHBOARD_PATH,
    testId: "class-demo-chooser-instructor",
  },
];
